<template>
    <div class="file-preview relative aspect-square overflow-hidden rounded-xl flex flex-col justify-between border border-neutral-3 bg-[#f1f4f4] whitespace-pre-wrap w-full h-full">
        <div @click.prevent="removeFile" @mouseenter="changeTrashFillLight" @mouseleave="changeTrashFillDark" class="h-6- w-6 rounded-bl flex justify-center bg-primary-extra-dark text-white hover:bg-secondary-dark hover:text-primary-extra-dark items-center cursor-pointer absolute top-0 right-0" aria-label="Remove">
            x
        </div>
        <img class="w-full block h-[80%] object-cover rounded-t-xl whitespace-pre-wrap" :src="file.iconURL" />
        <div class="rounded-b flex justify-between w-full border-t border-neutral-2 bg-neutral-0 px-2.5 py-1 ">
            <div class="truncate text-sm w-fit flex items-center">
                {{ file.title }}
            </div>
            <!-- <div class="w-7">
                <div @click.prevent="$emit('remove', file)" @mouseenter="changeTrashFillLight" @mouseleave="changeTrashFillDark"  class="h-7 w-7 rounded-br flex justify-center bg-primary hover:bg-tertiary-dark items-center cursor-pointer" aria-label="Remove">
                    <TrashSVG
                        :fill="trashSVGFill"
                    />
                </div>
            </div> -->
        </div>
    </div>
</template>

<script setup>
import { ref, defineProps, defineEmits } from 'vue';
const props = defineProps(['file'])
const emit = defineEmits(['remove-file'])

// :id="tempAttachment._id"
// :title="tempAttachment.title"
// :extension="tempAttachment.extension"
// :iconURL="tempAttachment.iconURL"
// :link="tempAttachment.link"
// :size="tempAttachment.size"

// const trashSVGFill = ref("#154B51")


// function changeTrashFillLight() {
//     trashSVGFill.value = "#743B06"
// }

// function changeTrashFillDark() {
//     trashSVGFill.value = "#154B51"
// }

function removeFile () {
    emit('remove-file', props.file._id)
}

</script>